// extracted by css-extract-rspack-plugin
export default {"appointmentSelector":"appointmentSelector-psd2wc"};